import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import globalMU from "globalMU"
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { WindowMU } from "app/types/WindowMU"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"


declare var window:WindowMU

export type DefinirQuantidadeTotalItemParams = {
    identificadorItem:number,
    adquirirQuantidadeTotal: boolean,
    itemOrcamentoLegado?: any,
    solicitacaoManual: boolean
}

export async function definirAdquirirQuantidadeTotalItem(input: DefinirQuantidadeTotalItemParams) {
    try {
    
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirAdquirirQuantidadeTotalItemOrcamento(
            store.getState().orcamento.IdentificadorOrcamento,
            input.identificadorItem, 
            input.adquirirQuantidadeTotal,
            input.solicitacaoManual)
        
            const atualizarOrcamento = () => {
                const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem);
                store.dispatch(atualizarItemAction({ identificador: input.identificadorItem, dados: itemAtualizado }))
                store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
            }
            
            atualizarOrcamento()

    }finally {
        globalMU.unblockUI()
    }
}
